<template>
    <div class="container">
        
        <div class="card border-0 shadow-lg">

            <img class="card-img-top w-100" src="https://i.ibb.co/KybCkxJ/Ond-Estudo-Graphic-01.png" alt="Card image cap">
            
            <div class="card-body">
                <div class="card-text text-justify app-description">
                    Já passaste horas à procura do sítio ideal para estudares?
                    <br>Apetece-te estudar numa biblioteca? Num jardim com amigos? Numa esplanada, ou simplesmente num sítio calmo?
                    <br>Com a OndEstudo podes encontrar o local perfeito para os teus desejos.
                    <br><br>Não queres perder muito tempo à procura de um lugar?
                    <br>. Baseada na tua localização, a OndEstudo recomenda os sítios mais perto de ti.
                    <br><br>Já sabes exatamente o que queres e só precisas de ver uma informação? 
                    <br>. Podes usar a barra de pesquisa para procurar esse mesmo sítio.
                    <br><br>Queres aventurar-te e descobrir um sítio novo e diferente?
                    <br>. Usa as coleções para encontrares o sítio ideal para ti e para o que queres naquele momento.
                    <br><br>De cada local, além de conseguires ver o quão ocupado está em tempo real, tens acesso a toda informação, desde horário, preço, localização e muito mais! Podes também ver as opiniões dos outros utilizadores e deixar a tua própria!
                    <br><br>Poderás também criar a tua própria coleção de espaços favoritos, para que os consigas ver mais facilmente. Podes também partilhar com os teus amigos um espaço que gostes!
                    <br><br>Desde faculdades, bibliotecas, jardins, cafés. Tudo isto à distância de uns cliques.
                    <br>Se quiseres, também podes contribuir e sugerir um local de estudo, que poderá vir a estar disponível para todos os utilizadores.
                </div>
            </div>
            
        </div>
    
    </div>
</template>

<style>
    
    .app-description{
        font-size: 2vh;
    }

</style>